import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/settings")({
  // Keep the query and hash: a saved link (e.g. ?tab=security) still lands where it pointed.
  beforeLoad: ({ location }) => {
    throw redirect({
      href: `/app/me/settings${location.searchStr}${location.hash ? `#${location.hash}` : ""}`,
      replace: true,
    });
  },
});
